import React, { FunctionComponent, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from '@blueprintjs/core';
import { JurisdictionAreaMenuActionsType } from 'routes/JurisdictionArea/jurisdictionArea.types';
import ModalDialog from 'shared/modal/dialog';
import { JurisdictionAreaGridData } from 'data/jurisdictionArea/jurisdictionArea.types';
import './jurisdiction-area-list-menu.scss';

type Props = {
  selectedJurisdictionArea?: JurisdictionAreaGridData;
  hasPrivilegeToCreateNew: boolean;
  hasPrivilegeToDelete: boolean;
  onEdit: () => void;
  onDelete: () => void;
}

const JurisdictionAreaListMenu: FunctionComponent<Props> = ({
  selectedJurisdictionArea,
  hasPrivilegeToCreateNew,
  hasPrivilegeToDelete,
  onEdit,
  onDelete,
}: Props) => {

  const [isDeleteDialogOpen, setIsDeleteDialogOpen] = useState(false);
  const { t } = useTranslation();

  const handleOpenDeleteDialog = () => {
    setIsDeleteDialogOpen(true);
  };

  const handleCloseDeleteDialog = () => {
    setIsDeleteDialogOpen(false);
  };

  const handleDelete = () => {
    onDelete();
    setIsDeleteDialogOpen(false);
  };

  if (selectedJurisdictionArea == null) {
    return null;
  }

  return (
    <div data-testid="JurisdictionAreaListMenu" className="jurisdiction-area-list-menu">
      {hasPrivilegeToCreateNew && (
        <Button
          className="jurisdiction-area-list-menu-button"
          data-testid={`${JurisdictionAreaMenuActionsType.Edit}-button`}
          text={t('jurisdictionArea.grid.edit')}
          onClick={onEdit}
        />
      )}
      {hasPrivilegeToDelete && (
        <Button
          className="jurisdiction-area-list-menu-button"
          data-testid={`${JurisdictionAreaMenuActionsType.Delete}-button`}
          text={t('jurisdictionArea.grid.delete')}
          onClick={handleOpenDeleteDialog}
        />
      )}
      <ModalDialog
        width="500px"
        isOpen={isDeleteDialogOpen}
        title={t('jurisdictionAreaGroup.deletePopup.title')}
        displayMessage={t('jurisdictionAreaGroup.deletePopup.message', { areaName: selectedJurisdictionArea.SS8ID })}
        actionText={t('jurisdictionAreaGroup.deletePopup.action')}
        onSubmit={handleDelete}
        onClose={handleCloseDeleteDialog}
      />
    </div>
  );
};

export default JurisdictionAreaListMenu;
